<script setup>
import { Message } from "element-plus";
import { ViewFileModelProps } from "./config";
import ViewFile from "../ViewFile/ViewFile.vue";
import { onMounted, ref, reactive, watch } from "vue";
import Service from "./Service";
import { getInitState } from "./State";

const props = defineProps(ViewFileModelProps);

const state = reactive(getInitState());
const service = new Service();

const checkFileType = fileType => {
  if (!fileType) {
    Message.error(`接口数据异常`);
    return false;
  } else {
    const fileTypeArr = [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "txt",
      "pdf",
      "docx",
    ];
    if (!fileTypeArr.includes(fileType)) {
      Message.warning(`暂不支持${fileType}类型文件预览`);
      return false;
    }
  }
  return true;
};

/**设置文件信息 */
const setFileInfo = async () => {
  let fileInfo;
  if (props.filePath) {
    fileInfo = await service.getFileInfoByPath(props.filePath);

  } else if (props.getFileInfo) {
    fileInfo = await props.getFileInfo();
  }
  if (checkFileType(fileInfo.filetype) === false) {
    return;
  }
  state.fileName = fileInfo.fileName;
  state.filetype = fileInfo.filetype;
  state.fileBlob = fileInfo.fileBlob;
};

watch(
  () => props.visible,
  () => {
    if (props.visible && (props.getFileInfo || props.filePath)) {
      setFileInfo();
    } else {
      state.fileName = "";
      state.filetype = "";
      state.fileBlob = null;
    }
  },
  {
    immediate: true,
  }
);
watch(
  () => props.filePath,
  () => {
   setFileInfo();
  },
  {
    immediate: true,
  }
);
</script>
<script>
export default {
  name: "ViewFileWapper",
};
</script>

<template>
  <div class="ViewFileModel" v-if="props.visible">
    <ViewFile :type="state.filetype" :stream="state.fileBlob" />
  </div>
</template>

<style scoped lang="scss">
.ViewFileModel {
  width: 100%;
  height: 100%;
  :deep(.word) {
    .ViewFileModel-docx-wrapper {
      background: none !important;
      padding: 10px;
      .ViewFileModel-docx {
        padding: 0 !important;
        width:unset !important;
        min-height: unset !important;
        margin: auto 15vw;
        min-width: unset !important;
        box-shadow: none;
        margin-bottom:2rem;
      }
    }
  }
}
</style>
